import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              株式会社伊藤総業
            </h3>
            <p className="text-gray-300 mb-4">
              東京都世田谷区を拠点とする総合企業として、中古車販売から再生可能エネルギー、不動産まで幅広い事業を展開しています。
            </p>
            <div className="space-y-2 text-gray-300">
              <div className="flex items-center">
                <i className="ri-map-pin-line mr-2"></i>
                <span>東京都世田谷区代沢五丁目二十四番一号</span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <span>03-6764-9633</span>
              </div>
              <div className="flex items-center">
                <i className="ri-printer-line mr-2"></i>
                <span>FAX: 03-6764-9633</span>
              </div>
              <div className="flex items-center">
                <i className="ri-user-line mr-2"></i>
                <span>代表：伊藤銀星</span>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4">事業内容</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <Link to="/used-cars" className="hover:text-white transition-colors cursor-pointer">
                  中古車販売・買取・輸出
                </Link>
              </li>
              <li>
                <Link to="/renewable-energy" className="hover:text-white transition-colors cursor-pointer">
                  再生可能エネルギー
                </Link>
              </li>
              <li>
                <Link to="/energy-storage" className="hover:text-white transition-colors cursor-pointer">
                  蓄電所運営
                </Link>
              </li>
              <li>
                <Link to="/web-development" className="hover:text-white transition-colors cursor-pointer">
                  ホームページ制作
                </Link>
              </li>
              <li>
                <Link to="/real-estate" className="hover:text-white transition-colors cursor-pointer">
                  不動産売買
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">会社情報</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <Link to="/company" className="hover:text-white transition-colors cursor-pointer">
                  会社概要
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-white transition-colors cursor-pointer">
                  お問い合わせ
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2026 株式会社伊藤総業. All rights reserved. | <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors cursor-pointer">Website Builder</a></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
